'use strict';
import angular from 'angular';
import './scripts/creatives.ctrls';
import './scripts/creatives.services';
import './scripts/creatives.directives';

import creativeLibraryHtmlUrl from './views/creative_library.html';
import creativeViewHtmlUrl from './views/creativeView.html';

angular.module('creativesLibrary', ['creatives.ctrls', 'creatives.services', 'creatives.directives'])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('creativeLibrary', {
                parent: 'layout',
                url: '/items/creativeLibrary',
                templateUrl: creativeLibraryHtmlUrl,
                controller:'CreativeLibraryController'
            })
            .state('viewCreative', {
                parent: 'layout',
                url: '/items/viewCreative/:creativeId',
                templateUrl: creativeViewHtmlUrl,
                controller: 'CreativeViewController',
            })

    }]);